import {updateUserStatus} from './reducers/update-user-status';
import {UserState} from './types';
import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

export const extraReducers = (builder: ActionReducerMapBuilder<UserState>) => {
  builder.addMatcher(updateUserStatus.matcher, updateUserStatus.reducer);
};
